import { LegalPage } from "@/components/LegalPage";

const SECTIONS = [
  ["1. Acceptance of Terms", ["By downloading, accessing, or using the Robo-X mobile application operated by RoboSpark PrP Pvt Ltd, you agree to these Terms of Service."]],
  ["2. Nature of Service", ["Robo-X is an algorithmic trading tool that provides signals, analysis, and practice trading features. It does not involve real-money trading. All trading activity within the app is for practice and educational purposes only."]],
  ["3. Subscription", null, [
    "Access to premium features requires a paid subscription.",
    "Pricing: ₹3,699 for the first month, thereafter ₹599 per month or ₹4,999 per year.",
    "Applicable GST (currently 18%) will be charged extra.",
    "Subscription is managed through Razorpay or Google Play Billing.",
    "Access will be locked upon expiry of the subscription until renewed."]],
  ["4. No Financial Advice", ["The app provides tools and information for educational and practice purposes. It does not constitute financial, investment, or trading advice. Users are solely responsible for their own decisions."]],
  ["5. User Responsibilities", ["You agree not to misuse the app, attempt to reverse-engineer it, or use it for any illegal purpose."]],
  ["6. Limitation of Liability", ["RoboSpark PrP Pvt Ltd shall not be liable for any losses, damages, or claims arising from the use of the app or reliance on its features."]],
  ["7. Termination", ["We may suspend or terminate access if these terms are violated."]],
];

export default function TermsOfService() {
  return <LegalPage prefix="terms" title="Robo-X Terms of Service" updated="3 November 2026" sections={SECTIONS} contactTitle="Contact"
    contactIntro="For any questions regarding these Terms, contact us at:"
    closing="By using Robo-X, you acknowledge that you have read and agreed to these Terms of Service." />;
}
